import { apiGet, apiPatch, apiPost, apiPut } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/promotions/subscription-gift/coupon', query)
      .then(result => result.response);
  },
  searchRedeems(query) {
    return apiGet('/magenta/promotions/subscription-gift/coupon/redeem', query)
      .then(result => result.response);
  },
  find(id) {
    return apiGet(`/magenta/promotions/subscription-gift/coupon/${id}`)
      .then(result => result.response);
  },
  create(data) {
    return apiPost('/magenta/promotions/subscription-gift/coupon', data)
      .then(result => result.response);
  },
  update(id, data) {
    return apiPatch(`/magenta/promotions/subscription-gift/coupon/${id}`, data)
      .then(result => result.response);
  },
  updateAvailableRedeems(id, data) {
    return apiPut(`/magenta/promotions/subscription-gift/coupon/${id}/available-redeems`, data)
      .then(result => result.response);
  },
  statusDescription: {
    "REDEEMED": 'Resgatado',
    "RESERVED": "Reservado",
    "CANCELED": "Cancelado"
  }
};
